import { render, staticRenderFns } from "./BrCodeCopiedSuccessful.vue?vue&type=template&id=0161cc28&"
import script from "./BrCodeCopiedSuccessful.vue?vue&type=script&lang=js&"
export * from "./BrCodeCopiedSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./BrCodeCopiedSuccessful.vue?vue&type=style&index=0&id=0161cc28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports